import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Cart from "./Cart";
import { getCartList, addToCart, deleteCartItem } from "../api/cartApi";
import { SUCCESS } from "../../../common/constants/commonConstant";

const CartContainer = () => {
  const navigate = useNavigate();
  const [carts, setCarts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCarts = useCallback(() => {
    getCartList()
      .then(data => {
        setCarts((data && data.carts) || []);
      })
      .catch(() => {})
      .then(() => setLoading(false));
  }, []);

  useEffect(() => {
    fetchCarts();
  }, [fetchCarts]);

  // 보관함에 도서명 직접 등록 (제목만 저장).
  const onAdd = useCallback(
    name => {
      const n = (name || "").trim();
      if (!n) return;
      addToCart([n])
        .then(data => {
          const result = data && data.result;
          if (!result || result.retCode !== SUCCESS) {
            alert((result && result.retMsg) || "보관함 등록에 실패했습니다.");
            return;
          }
          fetchCarts();
        })
        .catch(err => {
          if (err && err.tokenExpired) return;
          alert("보관함 등록에 실패했습니다.");
        });
    },
    [fetchCarts]
  );

  const onDelete = useCallback(cartSeq => {
    deleteCartItem(cartSeq)
      .then(data => {
        const result = data && data.result;
        if (!result || result.retCode !== SUCCESS) {
          alert((result && result.retMsg) || "보관함 삭제에 실패했습니다.");
          return;
        }
        setCarts(prev => prev.filter(c => c.cartSeq !== cartSeq));
      })
      .catch(err => {
        if (err && err.tokenExpired) return;
        alert("보관함 삭제에 실패했습니다.");
      });
  }, []);

  // 도서 신청 페이지로 이동해 해당 제목으로 바로 재검색 —
  // 보관 시점의 URL/가격은 이미 바뀌었을 수 있으므로 항상 새로 검색해서 고른다.
  const onRequest = useCallback(
    bookName => {
      navigate("/bookMultiRequest", { state: { searchKeyword: bookName } });
    },
    [navigate]
  );

  return (
    <Cart
      carts={carts}
      loading={loading}
      onAdd={onAdd}
      onDelete={onDelete}
      onRequest={onRequest}
    />
  );
};

export default CartContainer;
